module.exports = __webpack_public_path__ + "static/media/6.81cecc5e.jpg";